(() => {
  if (window.orrenlabInlineVideos) {
    window.orrenlabInlineVideos.init(document);
    return;
  }
  const players = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    root.querySelectorAll('[data-orrenlab-video-section] video').forEach((video) => {
      if (players.has(video)) return;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'orrenlab-video-toggle';
      button.textContent = 'Play video';
      button.hidden = true;
      video.parentElement.appendChild(button);
      let manuallyPaused = false;
      let blocked = false;
      let pending = false;
      const isVisible = () => {
        const rect = video.getBoundingClientRect();
        return !document.hidden && rect.width > 0 && rect.height > 0 &&
          rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      };
      const updateButton = () => {
        button.hidden = !isVisible();
        button.textContent = video.paused ? 'Play video' : 'Pause video';
        button.setAttribute('aria-label', video.paused ? 'Play wool close-up video' : 'Pause wool close-up video');
      };
      const play = (userInitiated = false) => {
        if (!isVisible() || pending || (!userInitiated && (manuallyPaused || reducedMotion.matches || blocked))) {
          updateButton();
          return;
        }
        if (!video.paused) return;
        if (userInitiated) {
          manuallyPaused = false;
          blocked = false;
          if (video.error) video.load();
        }
        video.preload = 'auto';
        pending = true;
        Promise.resolve(video.play()).catch((error) => {
          // A blocked autoplay must remain playable by an explicit tap.
          blocked = error.name !== 'AbortError';
        }).finally(() => {
          pending = false;
          updateButton();
        });
      };
      const sync = () => {
        if (isVisible()) play();
        else video.pause();
        updateButton();
      };
      const onCanPlay = () => play();
      const onPlaying = () => {
        if (!isVisible()) video.pause();
        updateButton();
      };
      button.addEventListener('click', () => {
        if (video.paused) play(true);
        else {
          manuallyPaused = true;
          video.pause();
          updateButton();
        }
      });
      video.addEventListener('canplay', onCanPlay);
      video.addEventListener('playing', onPlaying);
      video.addEventListener('pause', updateButton);
      video.addEventListener('error', updateButton);
      let preloadObserver;
      let playbackObserver;
      if ('IntersectionObserver' in window) {
        preloadObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !reducedMotion.matches) video.preload = 'auto';
          });
        }, { rootMargin: '240px 0px', threshold: 0.01 });
        playbackObserver = new IntersectionObserver(sync, { threshold: 0.01 });
        preloadObserver.observe(video);
        playbackObserver.observe(video);
      }
      players.set(video, {
        sync,
        destroy() {
          preloadObserver?.disconnect();
          playbackObserver?.disconnect();
          video.pause();
          video.removeEventListener('canplay', onCanPlay);
          video.removeEventListener('playing', onPlaying);
          video.removeEventListener('pause', updateButton);
          video.removeEventListener('error', updateButton);
          button.remove();
        },
      });
      sync();
    });
  }
  const syncAll = () => players.forEach((player) => player.sync());
  window.orrenlabInlineVideos = { init };
  init(document);
  document.addEventListener('visibilitychange', syncAll);
  window.addEventListener('pageshow', syncAll);
  window.addEventListener('resize', syncAll);
  if (!('IntersectionObserver' in window)) window.addEventListener('scroll', syncAll, { passive: true });
  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) players.forEach((_player, video) => video.pause());
    syncAll();
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    players.forEach((player, video) => {
      if (event.target.contains(video)) {
        player.destroy();
        players.delete(video);
      }
    });
  });
})();
